// import libs
//

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
import './components/ie-detection.js';
import './components/menu.js';
import './components/livePasswordValidation.js';
import './components/searchForm.js';
import './components/carFilter.js';
import './components/savedCarFilterModal.js';
//import './components/comparedCars.js';
import './components/modal.js';
import './components/financingReservationForm.js';
import './components/carReservationForm.js';
import './components/histogram.js';
import './components/filterByPrice.js';
import './components/filterSliders.js';
import './components/select2.js';
import './components/map.js';
import './components/share.js';
import './components/dataLayer.js';
import './components/modalpopup.js';
import './components/pageBlocks.js';

import './components/additionalFilter.js';
import './components/saveFilter.js';

import './components/carouselModelSeries.js';

import { set } from 'lodash';

var $scrollToItems = $('.scrollTo');
$.each($scrollToItems, function () {
    $(this).on('click', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');
        if (typeof href === 'undefined') {
            href = $(this).attr('data-href');
        }
        var offset = $(this).attr('data-offset');

        // if booking strip scroll to
        if ($(this).hasClass('scrolling-strip')) {
            const mq = window.matchMedia("(max-width: 576px)");
            if (mq.matches) {
                offset = 0;
            }
        }

        var $target = $(href);
        if ($target.length) {
            $('html,body').animate({
                scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 0)
            }, {
                duration: 0,
                easing: 'swing'
            });
        }
    });
});

$(document).ready(function() {
    const $teaserSlider = $('#teaserSlider');
    if ($teaserSlider.length > 0) {
        $teaserSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            // fade: true,
            // cssEase: 'linear',
            dots: true,
            infinite: true,
            arrows: false,
            centerMode: false,
            // centerPadding: '6rem',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        // dots: false,
                    }
                },
            ]
        });
    } else {
        // console.error("Slick container #teaserSlider nebyl nalezen!");
    }
});

function initCarCardCarousel($items, index = 0) {
    $items.each(function() {
        var $carousel = $(this);
        var slideCount = $carousel.children().length;

        if ($carousel.children().length === 0) {
            return;
        }
        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }
        var options = {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 300,
            dots: true,
            //infinite: true,
            infinite: slideCount > 1,
            arrows: true,
            centerMode: false,
            initialSlide: index,
            accessibility: slideCount > 1
        };
        $carousel.slick(options);

        $carousel.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            $(this).closest('.card-container').find('.carousel__index').text(currentSlide);
        });
    });
}
var $carCardCarousels = $('.card__carousel');
initCarCardCarousel($carCardCarousels);


var $reviewCarousels = $('.review__carousel');
function initReviewCarousel($items, index = 0) {
    $items.each(function() {
        var $carousel = $(this);
        var slideCount = $carousel.children().length;

        // Pokud již byl slider inicializován, zrušíme předchozí instanci
        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        // Pokud je slide jen jeden (nebo méně než 2), deaktivujeme infinite a accessibility
        var infiniteOption = slideCount > 1;
        var accessibilityOption = slideCount > 1;

        $carousel.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            speed: 300,
            dots: true,
            infinite: infiniteOption,
            arrows: false,
            centerMode: false,
            accessibility: accessibilityOption,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $carousel.on('setPosition', function () {
            $(this).find('.slick-slide').height('auto');
            var slickTrack = $(this).find('.slick-track');
            var slickTrackHeight = slickTrack.height();
            $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
        });

        $carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $(this).closest('.review-container').find('.review__index').text(currentSlide);
        });
    });
}
initReviewCarousel($reviewCarousels);

// refresh carousels on tab change (napriklad stranka modelova rada)
// $('.nav-tabs--filter').on('click', '.nav-link', function (e) {
//     // Skip refresh if the clicked tab is inside the FavoriteCars component
//     if ($(this).closest('.favorite-cars').length) {
//         return;
//     }
//     let $carousels = $(this).closest('.section').find('.card__carousel');
//     if ($carousels.length) {
//         $carousels.slick('refresh');
//     }
// });
$('.nav-tabs--filter').on('click', '.nav-link', function (e) {
    // Skip refresh if the clicked tab is inside the FavoriteCars component
    if ($(this).closest('.favorite-cars').length) {
        return;
    }
    let $carousels = $(this).closest('.section').find('.card__carousel');
    if ($carousels.length) {
        $carousels.each(function () {
            // Only refresh the slider if it's already initialized
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('refresh');
            }
        });
    }
});
$(document).ready(function () {
    $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        // Po krátkém zpoždění (aby se DOM aktualizoval) projdeme viditelné slick slider instance a zavoláme setPosition
        setTimeout(function () {
            $('.card__carousel:visible').each(function () {
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('setPosition');
                }
            });
        }, 50);
    });
});

function initLightbox() {
    $('.lightbox').each(function () { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: '.lightbox__item',
            gallery: {
                enabled: true
            },
            type: 'image',
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
                beforeOpen: function () {
                    // just a hack that adds mfp-anim class to markup
                    this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                    this.st.mainClass = this.st.el.attr('data-effect');
                }
            },
            closeOnContentClick: true,
            midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
        });
    });
}

initLightbox();

// dropdown header
const dropdowns = document.getElementsByClassName('dropdown-toggle');
for (let i = 0; i < dropdowns.length; i++) {
    dropdowns[i].addEventListener('show.bs.dropdown', event => {
        if ($(dropdowns[i]).closest('.header').length) {
            $('body').addClass('dropdown-open');
        }
    });

    dropdowns[i].addEventListener('hide.bs.dropdown', event => {
        if ($(dropdowns[i]).closest('.header').length) {
            $('body').removeClass('dropdown-open');
        }
    });
}


document.addEventListener("DOMContentLoaded", () => {
    // Livewire.hook('message.processed', (message, component) => {
    //     if ($(component.el).hasClass('card-container')) {
    //         var $carousel = $(component.el).find('.card__carousel');
    //         if ($carousel.length) {
    //             var currentIndex = parseInt($(component.el).find('.carousel__index').text());
    //             initCarCardCarousel($carousel, currentIndex);
    //         }
    //     }
    //
    //     if ($(component.el).hasClass('review-container')) {
    //         var $carousel = $(component.el).find('.review__carousel');
    //         if ($carousel.length) {
    //             var currentIndex = parseInt($(component.el).find('.review__index').text());
    //             initReviewCarousel($carousel, currentIndex);
    //         }
    //     }
    // });

    Livewire.hook('message.processed', (message, component) => {
        setTimeout(() => {
            if ($(component.el).hasClass('card-container')) {
                var $carousel = $(component.el).find('.card__carousel');
                if ($carousel.length > 0) {
                    if ($carousel.hasClass('slick-initialized')) {
                        $carousel.slick('unslick');
                    }
                    var currentIndex = parseInt($(component.el).find('.carousel__index').text(), 10) || 0;
                    initCarCardCarousel($carousel, currentIndex);
                }
            }

            if ($(component.el).hasClass('review-container')) {
                var $carousel = $(component.el).find('.review__carousel');
                if ($carousel.length > 0) {
                    if ($carousel.hasClass('slick-initialized')) {
                        $carousel.slick('unslick');
                    }
                    var currentIndex = parseInt($(component.el).find('.review__index').text(), 10) || 0;
                    initReviewCarousel($carousel, currentIndex);
                }
            }
        }, 300); // Zkuste třeba 300 ms nebo více
    });
});

function initReviews() {
    var swiperReviews = new Swiper(".swiper--reviews", {
        spaceBetween: 20,
        slidesPerView: 1.15,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            568: {
                slidesPerView: 1.75,
                //   spaceBetween: 20,
            },
            // 768: {
            // //   slidesPerView: 2.75,
            // //   spaceBetween: 40,
            // },
            992: {
                slidesPerView: 2.35,
                //   spaceBetween: 50,
            },
        },
    });
}
initReviews();

var $mainGalleries = $('.main-gallery');
for (var i = 0; i < $mainGalleries.length; i++) {
    var $gallery = $($mainGalleries[i]);

    var swiperThumbs = new Swiper($gallery.find('.swiper--thumbs')[0], {
        direction: "horizontal",
        spaceBetween: 4,
        slidesPerGroup: 3,
        slidesPerView: 3.15,
        freeMode: true,
        watchSlidesProgress: true,
        // loop: true,
        // navigation: false,
        breakpoints: {
            568: {
                direction: "horizontal",
                spaceBetween: 8,
                slidesPerView: 4.15,
                //   spaceBetween: 20,
            },
            992: {
                direction: "vertical",
                slidesPerView: "auto",
                slidesPerGroup: 4,
                spaceBetween: 8,
                navigation: {
                    nextEl: $gallery.find('.swiper-button-next')[0],
                    prevEl: $gallery.find('.swiper-button-prev')[0],
                },
            },
        },
    });

    var swiperMain = new Swiper($gallery.find('.swiper--main')[0], {
        speed: 300, // default
        spaceBetween: 20,
        navigation: {
            nextEl: $gallery.find('.swiperMain-button-next')[0],
            prevEl: $gallery.find('.swiperMain-button-prev')[0],
        },
        thumbs: {
            swiper: swiperThumbs,
        },
    });
}

var swiperColors = new Swiper(".swiper--colors", {
    speed: 300, // default
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {

            var hex = $(this.el).find('.swiper-slide img').eq(index).attr('data-color');

            return '<span style="color: ' + hex + '; background-color: ' + hex + ';" class="' + className + '"></span>';
        },
    },
});

var swiperAlternatives = new Swiper("#swiperAlternatives", {
    // spaceBetween: 20,
    slidesPerView: 1,
    freeMode: true,
    loop: false,
    // autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    // },
    // centeredSlides: true,
    navigation: {
        nextEl: ".swiperAlternative-button-next",
        prevEl: ".swiperAlternative-button-prev",
    },
    breakpoints: {
        568: {
            slidesPerView: 1,
            //   spaceBetween: 20,
        },
        800: {
            slidesPerView: 2,
            //   spaceBetween: 40,
        },
        1200: {
            slidesPerView: 3,
            //   spaceBetween: 50,
        },
    },
});

function initComparationCompact() {
    var swiperComparation = new Swiper(".swiper--comparation-compact", {
        spaceBetween: 8,
        slidesPerView: 2.75,
        // freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            568: {
                slidesPerView: 3,
                //   spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 12,
            },
            1200: {
                slidesPerView: 5,
                //   spaceBetween: 50,
            },
        },
    });
}

initComparationCompact();

document.addEventListener("livewire:navigated", () => {
    Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
        succeed(({ snapshot, effect }) => {
            queueMicrotask(() => {
                var $carousels = $(component.el).find('.card__carousel:not(.slick-initialized)');
                if ($carousels.length) {
                    initCarCardCarousel($carousels);
                }

        var $reviewCarousels = $(component.el).find('.review__carousel:not(.slick-initialized)');
        if ($reviewCarousels.length) {
            initReviewCarousel($reviewCarousels);
        }

        if ($(component.el).attr('id') == 'filterLivewire') {
            initReviews();
            initTagCloudCarousel();
            initCarModelSeriesCarousel();
            initComparationCompact();
        }

                if ($(component.el).attr('id') === 'comparationCompactLivewire') {
                    initComparationCompact();
                }

                if ($(component.el).attr('id') === 'search') {
                    setSearchIsFocused();
                }
            });
        });

        fail(() => {
            // console.log('Failed to process Livewire message.');
        });
    });
});

// Copy to clipboard
function copyToClipboard(elem) {
    var text = $(elem).attr('data-copy');
    var succeed;
    try {
        var el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        succeed = document.execCommand('copy');
        document.body.removeChild(el);

    } catch (e) {
        //console.warn(e);

        succeed = false;
    }

    // Restore original focus
    // if (currentFocus && typeof currentFocus.focus === "function") {
    //   currentFocus.focus();
    // }

    if (succeed) {
        $(elem).find(".copyToClipboard__copied").animate({top: -20, opacity: 1}, 700, function () {
            $(this).css({top: -5, opacity: 0});
        });
    }

    return succeed;
}

$(".copyToClipboard").on("click", function () {
    copyToClipboard($(this));
});

$('.togglePassword').on('click', function (e) {
    e.preventDefault();

    var $this = $(this);
    var $input = $this.closest('.input-group').find(".form-control");
    var type = $input.attr("type");
    var $icon = $this.find('.icon');

    if (type == "password") {
        $icon.attr('src', $icon.attr('data-src-off'));
        $input.attr("type", "text");
    } else if (type == "text") {
        $icon.attr('src', $icon.attr('data-src-on'));
        $input.attr("type", "password");
    }

});

$('.toggleLoginModal').on('click', function (e) {
    var target = $(this).attr('data-tab');
    $(`.nav-tabs button[data-bs-target="${target}"]`).tab('show');
});


// test if sticky is sticky
// https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
const el = document.getElementsByClassName('aside-layout__box--sticky');
if (el) {
    for (let i = 0; i < el.length; i++) {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
            {threshold: [1]}
        );
        observer.observe(el[i]);
    }
}

function setSearchIsFocused() {
    $('#header').find('.search__input-wrapper').addClass('is-focused');
}

$('.search__input').on('focus', function () {
    setSearchIsFocused();
});

$('.search__input').on('focusout', function () {
    $('#header').find('.search__input-wrapper').removeClass('is-focused');
});

// Card prevent default
$('body').on('click', '.card button', function (e) {
    // alert('button / prevent default');
    e.preventDefault();
    e.stopPropagation();
});

// additional filter mobile behavior
$('.additionalFilter__content-item').on('click', '.btn-close', function (e) {
    $(this).closest('.additionalFilter__content-item').removeClass('active');
});

// Detail - tlacitko "... zobrazit více"
$('.showMore__btn--more').on('click', function (e) {
    $(this).closest('.showMoreComponent').addClass('is-active');
});

$('.showMore__btn--less').on('click', function (e) {
    $(this).closest('.showMoreComponent').removeClass('is-active');

    // scroll To button
    var $target = $(this).closest('.showMoreComponent').find('.showMore__btn--more');
    if ($target.length) {
        $('html,body').animate({
            scrollTop: $target.offset().top - 50
        }, {
            duration: 0,
            easing: false
        });
    }

});

// Tag cloud carousel on filter
function initTagCloudCarousel() {
    $('.swiper--tagCloud.swiper-initialized').each(function () {
        this.swiper.destroy();
    });

    var tagcloudCarousel = new Swiper(".swiper--tagCloud", {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next-tagCloud",
            prevEl: ".swiper-button-prev-tagCloud",
        },
    });
}

function initCarModelSeriesCarousel() {
    // Zrušení předchozí instance (pokud Livewire překresluje)
    $('.swiper--carModelSeries.swiper-initialized').each(function () {
        this.swiper.destroy();
    });

    new Swiper('.swiper--carModelSeries', {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next-carModelSeries',
            prevEl: '.swiper-button-prev-carModelSeries',
        },
    });

    // add number of items
    $('.swiper--carModelSeries').each(function () {
        var $swiper = $(this);
        var $slides = $swiper.find('.swiper-slide').length;
        $swiper.attr('data-slides', $slides);

        // if arrow next is disabled
        $swiper.removeClass('offset-left-0');
        if ($slides && $swiper.find('.swiper-button-next-carModelSeries.swiper-button-lock').length) {
            $swiper.addClass('offset-left-0');
        }
    });
}

// waypoint
var waypointShowDetailCardFloatingBtns = $('#showdetailCardFloatingBtns').waypoint({
    handler: function (direction) {
        $('#detailCardFloatingBtns').toggleClass('show');
    },
    // offset: '100%'
})

function initTeaserSlider() {
    const $teaserSlider = $('#teaserSlider');
    if ($teaserSlider.length > 0) {
        if ($teaserSlider.hasClass('slick-initialized')) {
            $teaserSlider.slick('unslick');
        }

        const slideCount = $teaserSlider.children().length;

        $teaserSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            infinite: slideCount > 1,
            accessibility: slideCount > 1 ? true : false,
            arrows: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        // dots: false,
                    }
                },
            ]
        });
    }
}

function initializeDropdowns() {
    var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
    var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
        return new bootstrap.Dropdown(dropdownToggleEl);
    });
}

function initShowMoreEllipsis() {
    $('.showMoreEllipsisBtn').each(function () {
        var $content = $(this).parent().find('.showMoreEllipsisContent');
        if ($content.text().length > 900) {
            $(this).removeClass('d-none');
        }
    });

    $('.showMoreEllipsisBtn').on('click', function () {
        var $container = $(this).parent();
        $container.find('.showMoreEllipsisContent').removeClass('ellipsis-4');
        $(this).addClass('d-none');
        $container.find('.showLessEllipsisBtn').removeClass('d-none');
    });

    $('.showLessEllipsisBtn').on('click', function () {
        var $container = $(this).parent();
        $container.find('.showMoreEllipsisContent').addClass('ellipsis-4');
        $(this).addClass('d-none');
        $container.find('.showMoreEllipsisBtn').removeClass('d-none');
    });
}

$(document).ready(function() {
    // initializeDropdowns();
    initLightbox();
    initReviews();
    initComparationCompact();
    initTagCloudCarousel();
    initCarModelSeriesCarousel();
    initCarCardCarousel($('.card__carousel:not(.slick-initialized)'));
    // if (!$('.card__carousel').hasClass('slick-initialized')) {
    //     initCarCardCarousel($('.card__carousel'));
    // }
    initTeaserSlider();
    // initSelect2Single();
    initShowMoreEllipsis();
});

document.addEventListener('livewire:init', function () {
    Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
        succeed(({ snapshot, effect }) => {
            queueMicrotask(() => {
                initLightbox();
                initReviews();
                initComparationCompact();
                initTagCloudCarousel();
                initCarModelSeriesCarousel();
                initCarCardCarousel($('.card__carousel:not(.slick-initialized)'));
                initTeaserSlider();

                initShowMoreEllipsis();
            });
        });

        fail(() => {
            // console.error('Failed to process Livewire message.');
        });
    });
});

document.addEventListener('livewire:navigated', function ()  {
    initializeDropdowns();
    initLightbox();
    initReviews();
    initComparationCompact();
    initTagCloudCarousel();
    initCarModelSeriesCarousel();
    initCarCardCarousel($('.card__carousel:not(.slick-initialized)'));
    initTeaserSlider();
    initShowMoreEllipsis();

    Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
        succeed(({ snapshot, effect }) => {
            queueMicrotask(() => {
                initLightbox();
                initReviews();
                initComparationCompact();
                initTagCloudCarousel();
                initCarModelSeriesCarousel();
                initCarCardCarousel($('.card__carousel:not(.slick-initialized)'));
                initTeaserSlider();
                initShowMoreEllipsis();
            });
        });

        fail(() => {
            // console.error('Failed to process Livewire message.');
        });
    });
});

document.addEventListener('livewire:navigate', function () {
    var swiperElementTagCloud = document.querySelector('.swiper--tagCloud');
    if (swiperElementTagCloud && swiperElementTagCloud.swiper) {
        swiperElementTagCloud.swiper.destroy(true, true);
    }
    var swiperElementCarModelSeries = document.querySelector('.swiper--carModelSeries');
    if (swiperElementCarModelSeries && swiperElementCarModelSeries.swiper) {
        swiperElementCarModelSeries.swiper.destroy(true, true);
    }
});

document.addEventListener('storeScrollPosition', function() {
    sessionStorage.setItem('scrollPosRed', window.scrollY);
});

// Restore scroll position on page load
window.addEventListener('livewire:navigated', function () {
    const scrollPosRed = sessionStorage.getItem('scrollPosRed');
    if (scrollPosRed !== null) {
        // Delay the scroll restoration slightly to ensure the content is ready
        setTimeout(function() {
            window.scrollTo({top: parseInt(scrollPosRed), left: 0, behavior: 'instant'});
            sessionStorage.removeItem('scrollPosRed');
        }, 0); // You can adjust the delay if needed
    }
});

document.addEventListener('livewire:navigate', (event) => {
    // Show spinner when a navigation is triggered.
    const spinner = document.getElementById('spinnerTest');
    if (spinner) {
        spinner.classList.remove('d-none');
    }
});

document.addEventListener('livewire:navigated', (event) => {
    // Hide spinner after navigation is complete.
    const spinner = document.getElementById('spinnerTest');
    if (spinner) {
        spinner.classList.add('d-none');
    }
});

window.addEventListener('disable-filters', () => {
    document.querySelectorAll('#filter input, #filter select, #filter button')
        .forEach(el => el.disabled = true);
});
